import {emitter, EVENTS} from '../emitter';

export class Window {
  public static width: number;
  public static height: number;
  public static halfWidth: number;
  public static halfHeight: number;
  public static scaleFactor: number;

  constructor() {
    window.addEventListener('resize', (event: Event) => this.resizeHandler(event));
    window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('webkitfullscreenchange', this.fullscreenHandler);
    window.addEventListener('keydown', this.keyHandler);
    this.resizeHandler();
  }

  private keyHandler(event?: KeyboardEvent): void {
    if (event.keyCode) emitter.emit(EVENTS.keyEscape, {});
  }

  private fullscreenHandler(event: MouseEvent): void {
    emitter.emit(EVENTS.fullScreen, {});
  }

  private resizeHandler(event?: Event): void {
    Window.width = window.innerWidth;
    Window.height = window.innerHeight;
    Window.halfWidth = Math.round(Window.width * 0.5);
    Window.halfHeight = Math.round(Window.height * 0.5);
    Window.scaleFactor = Window.width / 1440;
    emitter.emit(EVENTS.resize, {width: Window.width, height: Window.height});
  }

  private scrollHandler(event: MouseEvent): void {
    emitter.emit(EVENTS.scroll, {y: window.scrollY});
  }
}
